// Core
import { useState } from "react";

// Internal
import coverImage from "../assets/cover-b.jpg";

export default function ComponentB() {
  console.log("Component B has been created");
  console.log("\n");

  const [count, setCount] = useState(0);

  function increaseCount() {
    setCount(count + 1);
    console.log("Component B count:", count);
  }

  return (
    <article className="my-component">
      <img src={coverImage} alt="A yin-yang symbol made of metal" />
      <p>
        Component B count <b>{count}</b>
      </p>
      <button onClick={increaseCount}>Increase count</button>
    </article>
  );
}
